import { Flex, Button, ButtonText, Icon, Typography } from '@percent/lemonade'
import { StepProps } from './Step.types'
import styles from './Step.module.scss'
import { ProgressBar } from '../ProgressBar/ProgressBar'

export function Step({
  title,
  description,
  onBack,
  onNext,
  nextButtonLabel,
  nextButtonDisabled,
  isLoading,
  children,
  progress
}: StepProps) {
  return (
    <>
      {onBack && (
        <ButtonText
          variant="primary"
          size="sm"
          onClick={onBack}
          className={styles.backButton}
          data-testid="step-back-button"
        >
          <Icon name="arrow-left" size="m" />
        </ButtonText>
      )}
      <ProgressBar progress={progress} />
      <Flex className={styles.step} key={description}>
        {title && (
          <Typography variant="h2" className={styles.title}>
            {title}
          </Typography>
        )}
        {description && <Typography className={styles.description}>{description}</Typography>}
        {children}
        {onNext && nextButtonLabel && (
          <div className={styles.buttonWrapper}>
            <Button
              onClick={onNext}
              data-testid="step-next-button"
              loading={isLoading}
              stretch
              disabled={isLoading || nextButtonDisabled}
            >
              {nextButtonLabel}
            </Button>
          </div>
        )}
      </Flex>
    </>
  )
}
